import { useState, FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../lib/api';
import { useAuth } from '../lib/auth';

export function Login() {
  const { refresh, user } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [totp, setTotp] = useState('');
  const [needTotp, setNeedTotp] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  if (user) { nav('/'); return null; }

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setErr(null); setBusy(true);
    try {
      await api.post('/auth/login', { email, password, totp: needTotp ? totp : undefined });
      await refresh();
      nav('/');
    } catch (ex: any) {
      if (ex.body?.error === 'totp_required') setNeedTotp(true);
      else setErr(ex.body?.error || ex.message);
    } finally { setBusy(false); }
  }

  return (
    <div className="login-wrap">
      <div className="login-card">
        <h1>Sign in</h1>
        <form onSubmit={onSubmit}>
          <div className="field">
            <label>Email</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} autoFocus required />
          </div>
          <div className="field">
            <label>Password</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} required />
          </div>
          {needTotp && (
            <div className="field">
              <label>Authenticator code</label>
              <input value={totp} onChange={e => setTotp(e.target.value)} inputMode="numeric" pattern="[0-9]*" required />
            </div>
          )}
          {err && <div style={{ color: '#ff6b6b', marginBottom: 10 }}>{err}</div>}
          <button disabled={busy} type="submit" style={{ width: '100%' }}>{busy ? 'Signing in…' : 'Sign in'}</button>
        </form>
        {/*
          SSO buttons hidden for now — accounts are managed manually via the
          Admin page. The server-side Google/Microsoft strategies still load
          conditionally (passport.ts skips them when GOOGLE_CLIENT_ID /
          MS_CLIENT_ID env vars are empty), so SSO can be re-enabled later
          by setting env vars and removing this `false &&` guard — no
          additional server code changes required.
        */}
        {false && (
          <div className="alt">
            <a className="btn ghost" href="/auth/microsoft">Microsoft</a>
            <a className="btn ghost" href="/auth/google">Google</a>
          </div>
        )}
      </div>
    </div>
  );
}
